// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoClearOutlinedSvg from "@fishx/icons-svg/es/asn/PtoClearOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoClearOutlined = function PtoClearOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoClearOutlinedSvg
  }));
};

PtoClearOutlined.displayName = 'PtoClearOutlined';
export default React.forwardRef(PtoClearOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoClearOutlined.js
// module id = 3889
// module chunks = 0